import { v4 } from 'uuid';
import { CarStatus, ConditionType } from './types';

export const NEW_CAR_INITIAL_VALUE = {
  title: '',
  status: CarStatus.DRAFT,
  description: '',
  generalThumbnail: null,
  files: [],
  isRentable: true,
  options: [],
  minimumDamagePrice: undefined,
  maximumDamagePrice: undefined,
  numberOfTrees: undefined,
  characteristics: [],
  pickupAndReturnLocations: [],
  currentMileage: 0,
  shortDescription: '',
  videoFile: null,
  registrationDoc: null,
  insuranceDoc: null,
  initialCarPhotos: [],
  upcomingActions: [
    {
      id: v4(),
      title: 'Inspection',
      date: null,
    },
    {
      id: v4(),
      title: 'Insurance',
      date: null,
    },
    {
      id: v4(),
      title: 'Annual service',
      date: null,
    },
  ],
  conditions: [
    {
      title: 'Age',
      value: '',
      type: ConditionType.DRIVER_MINIMUM_AGE,
    },
    {
      title: 'License',
      value: '',
      type: ConditionType.DRIVER_LICENCE_AGE,
    },
  ],
};
